import { get } from 'utilities/http';

export class AuthenticationService {

    getAuthenticationState = (): Promise<IAuthenticateState> => {
        return get<IAuthenticateState>('alo/v1/admin/AuthenticationState').then(result => {

            if (result.success) {
                return result.data;
            }
            else if (result.errors.length > 0) {
                const err = result.errors[0];

                if (err === 'Maximum connections to LiftIQ has been exceeded.') {
                    $('#splash').append("<div id='splash-message'><h1>Maximum connections to LiftIQ has been exceeded</h1></div>");
                }
            }
          
            return null;
        });
    }
}

export default new AuthenticationService();